<template>
  <svg
    id="contour_copia"
    data-name="contour copia"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <title>45_settings-LIGHT</title>
    <path
      fill="#679940"
      class="cls-1"
      d="M32,17A15,15,0,1,0,47,32,15,15,0,0,0,32,17Zm0,26A11,11,0,1,1,43,32,11,11,0,0,1,32,43Z"
    />
    <path
      fill="#679940"
      class="cls-1"
      d="M61.24,25.7l-2.54-.82a4,4,0,0,1-2.48-2.35l-.39-.94a4,4,0,0,1,.09-3.43l1.21-2.38a4,4,0,0,0-.74-4.64L52.86,7.61A4,4,0,0,0,50,6.44a4,4,0,0,0-1.81.43L45.84,8.08a3.92,3.92,0,0,1-1.8.44,4.05,4.05,0,0,1-1.63-.35l-.94-.39A4,4,0,0,1,39.12,5.3L38.3,2.76A4,4,0,0,0,34.49,0h-5A4,4,0,0,0,25.7,2.76L24.88,5.3a4,4,0,0,1-2.35,2.48l-.94.39A4.05,4.05,0,0,1,20,8.52a3.92,3.92,0,0,1-1.8-.44L15.78,6.87A4,4,0,0,0,14,6.44a4,4,0,0,0-2.83,1.17L7.61,11.14a4,4,0,0,0-.74,4.64l1.21,2.38a4,4,0,0,1,.09,3.43l-.39.94A4,4,0,0,1,5.3,24.88l-2.54.82A4,4,0,0,0,0,29.51v5A4,4,0,0,0,2.76,38.3l2.54.82a4,4,0,0,1,2.48,2.35l.39.94a4,4,0,0,1-.09,3.43L6.87,48.22a4,4,0,0,0,.74,4.64l3.53,3.53A4,4,0,0,0,14,57.56a4,4,0,0,0,1.81-.43l2.38-1.21a3.92,3.92,0,0,1,1.8-.44,4.05,4.05,0,0,1,1.63.35l.94.39a4,4,0,0,1,2.35,2.48l.82,2.54A4,4,0,0,0,29.51,64h5a4,4,0,0,0,3.81-2.76l.82-2.54a4,4,0,0,1,2.35-2.48l.94-.39A4.05,4.05,0,0,1,44,55.48a3.92,3.92,0,0,1,1.8.44l2.38,1.21a4,4,0,0,0,1.81.43,4,4,0,0,0,2.83-1.17l3.53-3.53a4,4,0,0,0,.74-4.64l-1.21-2.38a4,4,0,0,1-.09-3.43l.39-.94a4,4,0,0,1,2.48-2.35l2.54-.82A4,4,0,0,0,64,34.49v-5A4,4,0,0,0,61.24,25.7Zm-3.78,9.62a8,8,0,0,0-5,4.69l-.33.79a8,8,0,0,0,.18,6.86L53.56,50,50,53.56l-2.38-1.21A8,8,0,0,0,44,51.48a7.89,7.89,0,0,0-3.24.69L40,52.5a8,8,0,0,0-4.69,5L34.49,60h-5l-.83-2.54a8,8,0,0,0-4.69-5l-.79-.33A7.89,7.89,0,0,0,20,51.48a8,8,0,0,0-3.62.87L14,53.56,10.44,50l1.21-2.38a8,8,0,0,0,.18-6.86L11.5,40a8,8,0,0,0-5-4.69L4,34.49v-5l2.54-.83a8,8,0,0,0,5-4.69l.33-.79a8,8,0,0,0-.18-6.86L10.44,14,14,10.44l2.38,1.21a8,8,0,0,0,3.62.87,7.89,7.89,0,0,0,3.24-.69L24,11.5a8,8,0,0,0,4.69-5L29.51,4h5l.83,2.54a8,8,0,0,0,4.69,5l.79.33a7.89,7.89,0,0,0,3.24.69,8,8,0,0,0,3.62-.87L50,10.44,53.56,14l-1.21,2.38a8,8,0,0,0-.18,6.86l.33.79a8,8,0,0,0,5,4.69l2.54.83v5Z"
    />
  </svg>
</template>

<script>
export default {
  name: "SettingIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/SettingsIcon.vue